module.exports = __webpack_public_path__ + "img/text-underline.470810ea.svg";